import { useState } from "react";
import LessonOne from "./assets/Levels/Level 1/LessonOne";

import videoOne from "./assets/First Meetings 1.mp4";
import LessonTwo from "./assets/Levels/Level 1/LessonTwo";
import LessonThree from "./assets/Levels/Level 1/LessonThree";
import LessonFour from "./assets/Levels/Level 1/LessonFour";
import LessonFive from "./assets/Levels/Level 1/LessonFive";
import LessonSix from "./assets/Levels/Level 1/LessonSix";
import LessonSeven from "./assets/Levels/Level 1/LessonSeven";
import LessonEight from "./assets/Levels/Level 1/LessonEight";
import LessonNine from "./assets/Levels/Level 1/LessonNine";
import LessonTen from "./assets/Levels/Level 1/LessonTen";
import LessonEleven from "./assets/Levels/Level 1/LessonEleven";

export const CourseData = [
  {
    title: "Lesson 1",
    video: videoOne,
    completed: false,
    discription: "This lesson teaches you basic use of verb to be",
    path: "lessonone/*",
    element: <LessonOne />,
  },
  {
    title: "Lesson 2",
    video: videoOne,
    completed: false,
    discription: "This lesson teaches you basic use of verb to be",
    path: "lessontwo/*",
    element: <LessonTwo />,
  },
  {
    title: "Lesson 3",
    video: videoOne,
    completed: false,
    discription: "This lesson teaches you basic use of verb to be",
    path: "lessonthree/*",
    element: <LessonThree />,
  },
  {
    title: "Lesson 4",
    video: videoOne,
    completed: false,
    discription: "This lesson teaches you basic use of verb to be",
    path: "lessonfour/*",
    element: <LessonFour />,
  },
  {
    title: "Lesson 5",
    video: videoOne,
    completed: false,
    discription: "This lesson teaches you basic use of verb to be",
    path: "lessonfive/*",
    element: <LessonFive />,
  },
  {
    title: "Lesson 6",
    video: videoOne,
    completed: false,
    discription: "This lesson teaches you basic use of verb to be",
    path: "lessonsix/*",
    element: <LessonSix />,
  },
  {
    title: "Lesson 7",
    video: videoOne,
    completed: false,
    discription: "This lesson teaches you basic use of verb to be",
    path: "lessonseven/*",
    element: <LessonSeven />,
  },
  {
    title: "Lesson 8",
    video: videoOne,
    completed: false,
    discription: "This lesson teaches you basic use of verb to be",
    path: "lessoneight/*",
    element: <LessonEight />,
  },
  {
    title: "Lesson 9",
    video: videoOne,
    completed: false,
    discription: "This lesson teaches you basic use of verb to be",
    path: "lessonnine/*",
    element: <LessonNine />,
  },
  {
    title: "Lesson 10",
    video: videoOne,
    completed: false,
    discription: "This lesson teaches you basic use of verb to be",
    path: "lessonten/*",
    element: <LessonTen />,
  },
  {
    title: "Lesson 11",
    video: videoOne,
    completed: false,
    discription: "This lesson teaches you basic use of verb to be",
    path: "lessoneleven/*",
    element: <LessonEleven />,
  },
];
